import React from 'react'
import { HBox, Wrapper } from 'src/ui/layout'
import { Body, Header } from 'src/ui/typography'
import { WAVES_BIG_TEXT } from './constants'
import { SwiperSlider } from 'src/ui/organisms'
import { SwiperSlide } from 'swiper/react/swiper-react.js'
import { Image } from 'src/ui/atoms'

type Props = {
  images: TImages
}

export const Waves = ({ images }: Props) => {
  return (
    <Wrapper>
      <HBox />

      <Header as="h4" size="h4">
        KODE WAVES
      </Header>

      <HBox />

      <Body>{WAVES_BIG_TEXT}</Body>

      <HBox />

      <SwiperSlider>
        <SwiperSlide>
          <Image fluid={images['waves-mob']} />
        </SwiperSlide>
        <SwiperSlide>
          <Image fluid={images['waves-mob2']} />
        </SwiperSlide>
      </SwiperSlider>
    </Wrapper>
  )
}
